/**
 * Input Device Capabilities Detector
 */

export interface InputDeviceResult {
  pointerEvents: number;
  maxTouchPoints: number;
}

export async function detectInputDeviceCapabilities(): Promise<InputDeviceResult> {
  try {
    return {
      pointerEvents: (navigator as Navigator & { pointerEnabled?: boolean }).pointerEnabled ? 1 : 0,
      maxTouchPoints: navigator.maxTouchPoints || 0,
    };
  } catch (error) {
    return {
      pointerEvents: 0,
      maxTouchPoints: 0,
    };
  }
}
